/* External */
import { useCallback, useMemo, useReducer } from 'react';
import { Record } from 'immutable';

const StateRecord = Record({
  isLoading: false,
  isError: false,
  error: undefined,
  response: undefined,
});

const intialState = StateRecord();

const INIT = 'INIT';
const SUCCESS = 'SUCCESS';
const ERROR = 'ERROR';
const RESET = 'RESET';

function createStateReducer(processResponse = (oldResponse, newResponse) => newResponse) {
  return function stateReducer(currentState, { type, payload }) {
    switch (type) {
      case INIT: {
        return currentState.merge({ isLoading: true });
      }
      case SUCCESS: {
        return currentState.merge({
          isLoading: false,
          isError: false,
          error: undefined,
          response: processResponse(currentState.response, payload),
        });
      }
      case ERROR: {
        return currentState.merge({
          isLoading: false,
          isError: true,
          error: payload,
          response: undefined,
        });
      }
      case RESET: {
        return intialState;
      }
      default: {
        return currentState;
      }
    }
  };
}

export default function useRequestReducer(request, processResponse) {
  const stateReducer = useMemo(() => createStateReducer(processResponse), [processResponse]);
  const [state, dispatch] = useReducer(stateReducer, intialState);

  const performRequest = useCallback(
    async (...args) => {
      try {
        dispatch({ type: INIT });
        const response = await request(...args);
        dispatch({ type: SUCCESS, payload: response });
      } catch (error) {
        console.error('useRequestReducer>performRequest', error);

        dispatch({ type: ERROR, payload: error });
      }
    },
    [request],
  );

  const reset = useCallback(() => dispatch({ type: RESET }), []);

  return { state, performRequest, reset };
}
